import { render, staticRenderFns } from "./RoleEdit.vue?vue&type=template&id=11b010fc&scoped=true"
import script from "./RoleEdit.vue?vue&type=script&lang=js"
export * from "./RoleEdit.vue?vue&type=script&lang=js"
import style0 from "./RoleEdit.vue?vue&type=style&index=0&id=11b010fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b010fc",
  null
  
)

export default component.exports